<template>
  <div>
    <Modal
      class="my-modal top"
      v-model="visible"
      transfer
      :title="formData.id ? '编辑' : '新增' + '分类'"
      :mask-closable="false"
      :footer-hide="true"
      width="600px"
    >
      <Form ref="form" :model="formData" :label-width="80">
        <FormItem prop="name" label="分类名称" :rules="$units.formRule.required('请输入分类名称')">
          <Input v-model="formData.name" placeholder="请输入" clearable />
        </FormItem>
        <FormItem prop="parentId" label="父级" v-if="!showParent">
          <Select v-model="formData.parentId" transfer placeholder="请选择" clearable>
            <Option v-for="item in columnList" :key="item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem prop="isShow" label="是否启用">
          <i-switch v-model="formData.isShow" true-value="1" false-value="0"></i-switch>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="confirm">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      columnList: [],
      formData: {
        parentId: '',
        type: 1,
        id: '',
        name: '',
        isShow: '1',
        remark_: ''
      },
      showParent: false
    };
  },
  methods: {
    getColumnList(id) {
      this.$http({
        url: '/buz/cmsColumn/read/list',
        type: 'POST',
        data: {
          type: 1
        }
      }).then(res => {
        if (id) {
          this.columnList = res.data.filter(item => item.id != id);
        } else {
          this.columnList = res.data;
        }
      });
    },
    open(item) {
      this.formData.id = '';
      this.visible = true;
      this.$refs.form.resetFields();
      if (item.id) {
        this.formData.id = item.id;
        this.showParent = item.children.length > 0;
        this.getDetail();
      }
      this.getColumnList(item.id);
    },
    getDetail() {
      this.$http({
        url: '/buz/cmsColumn/read/detail',
        type: 'GET',
        data: { id: this.formData.id }
      }).then(res => {
        if (res.data.parentId == 0) {
          delete res.data.parentId;
        } else {
          res.data.parentId = res.data.parentId;
        }
        this.formData = res.data;
      });
    },
    confirm() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        let data = JSON.parse(JSON.stringify(this.formData));
        this.$http({
          url: data.id ? '/buz/cmsColumn/edit' : '/buz/cmsColumn/add',
          type: 'POST',
          data
        }).then(res => {
          this.$notice.success('操作成功');
          this.visible = false;
          this.$emit('success');
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/.ivu-modal-body {
    padding: 20px 20px 80px;
    overflow: unset;
  }
}
</style>
